import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "back-arrow",
  "use": "back-arrow-usage",
  "viewBox": "0 0 21 10",
  "content": "<symbol viewBox=\"0 0 21 10\" xmlns=\"http://www.w3.org/2000/svg\" id=\"back-arrow\"><path d=\"M170 267.999286L174.999286 273 174.999286 269.427653 190.711327 269.427653 190.711327 266.572347 174.999286 266.572347 174.999286 263z\" transform=\"translate(-170 -263)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/svg/back-arrow.svg
// module id = 1725
// module chunks = 0